import { render, staticRenderFns } from "./priceManage.vue?vue&type=template&id=44bd4962&scoped=true"
import script from "./priceManage.vue?vue&type=script&lang=js"
export * from "./priceManage.vue?vue&type=script&lang=js"
import style0 from "./priceManage.vue?vue&type=style&index=0&id=44bd4962&prod&scoped=true&lang=css"
import style1 from "./priceManage.vue?vue&type=style&index=1&id=44bd4962&prod&lang=css"
import style2 from "./priceManage.vue?vue&type=style&index=2&id=44bd4962&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bd4962",
  null
  
)

export default component.exports